export default {
  computed: {
    meta () {
      // Any meta field information needed for a particular backend...Wufoo
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/meta.js